import { useQuery } from 'react-query';

import { getCard as queryFn } from 'api/endPoints/getCard';
import { QueryKeys } from 'api/queryKeys';

import {
    ExternalDocument,
    IAssignee,
    ICardIndicators,
    ICategory,
    IComment,
    IContract,
    IExternalLink,
    IProject,
    IRelatedActivity,
    IStatus,
    ITagList,
} from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { CardType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';

export const useQueryGetCard = (params) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['getCard', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.id) && params.id !== 'newCard',
    });
};

export interface QueryResponse {
    id: number;
    type: {
        id: number;
        name: CardType;
        label: string;
    };
    category: ICategory;
    project: IProject;
    contract: IContract;
    assignee: IAssignee | null;
    laneId: {
        id: string | number;
        name: string;
        label: string;
    };
    title: string;
    details: string;
    relatedActivity: IRelatedActivity;
    mentionedList: string[];
    startDate: number;
    endDate: number;
    baselinePlannedStartDate: number;
    baselinePlannedEndDate: number;
    comments: IComment[];
    tagList: ITagList[];
    externalLinks: IExternalLink[];
    externalDocuments: ExternalDocument[];
    relatedCardIds: null;
    taskHashCode: string;
    taskVersionHashCode: string;
    taskId: number;
    rank: number;
    metaData: {
        id: number;
        versionName: string;
        sourceFile: string;
        versionDate: number;
    };
    duration: number;
    float: number | null;
    isVirtual: boolean;
    additionalData: null;
    recommendationType: null;
    isTracked: boolean;
    submittedDurationComplete: number;
    isStartOverdue: boolean;
    isFinishOverdue: boolean;
    cardIndicators: ICardIndicators;
    isLoose: boolean;
    isImportant: boolean;
    originalStatus: IStatus;
    status: IStatus;
    activityConstraints: {
        constraintName: string;
        constraintDate: number | null;
        constraintGroup: string | null;
    };
    remainingDurationInDays: number | null;
    isFoundInBaseline: boolean;
    originalStartDate: number;
    originalEndDate: number;
    isInterimChanged: boolean;
}
